module.exports = __webpack_public_path__ + "static/media/technogy3.ea3f695b.png";